import React from 'react';
import './OopsPage.css';
import opsImage from '../../assets/Images/ops.png'

const OopsPage = () => {
  return (
    <div className="oops-page">
      <div className='ops-section'>

        <img
          src={opsImage}
          alt="Mike Wazowski"
          className="error-image"
        />
        <div className="message">
          <h1>Oops!...</h1>
          <h2>
            An error has occurred, please try again.
          </h2>
        </div>
      </div>
    </div>
  );
};

export default OopsPage;
